import 'isomorphic-fetch'
import * as $$BASE from '../actions/baseAction'
import * as $$USER from '../actions/userAction'
import * as USER_TYPE from '../constants/types/userTypes'
import $CACHE from '../helpers/cache'
import { DOMAIN, CLIENT_SOURCE } from '../constants/config'
import { Hex_MD5, getCookie } from '../helpers/unit'

window._FETCHING={};

function checkStatus(response) {
    if(response.status === 200) {
        return response
    } else {
        var error = new Error(response.statusText);
        error.response = response;
        throw error;
    }
}

function request({ url, method, data }, successCallback, errorCallback) {
    fetch(DOMAIN + url + '&client=m',{
        credentials: 'include',
        method: method || 'GET',
        headers: {
            'Authorization': 'bearer ' + window.AUTH_TOKEN,
            'Content-Type': 'application/vnd.sc-api.v1.json',
            'Source': CLIENT_SOURCE[window.CLIENT_INFOS.source]
        },
        body: data ? JSON.stringify(data) : undefined
    })
    .then(checkStatus)
    .then(response => response.json())
    .then(successCallback)
    .catch(errorCallback);
}

// 生成请求 KEY
function uniqueFetch(url, method){
    return Hex_MD5(url + method);
}

export default store => next => action => {

 	if(!action.dirtyPayload || !action.dirtyPayload.url) {
        return next(action);
    }

    const { loading, cache, errorProcess, url, method, data } = action.dirtyPayload;
    /**
     * _error_ : 错误时额外操作
     * _success_ : 成功时额外操作
     */
    const { type, _error_, _success_, _done_, ignoreError } = action;

    // 唯一请求
    const requestUniqueKey = uniqueFetch(url, method);

    if (window._FETCHING[requestUniqueKey]) {
        return;
    }else{
        window._FETCHING[requestUniqueKey] = true;
    }

    // LOADING
    if (loading) {
        store.dispatch( $$BASE.openLoading() );
    };

    return request({ url, method, data }, 
    dirtyPayload => {

        // 开发环境打印响应
        if ((window.MODEL=='dev' || process.env.NODE_ENV == 'dev') && !window.DISABLE_HTTP_LOG) {
            console.group('#REQUEST LOG @DATE:' + new Date());
            console.info('#请求地址: ' + url);
            console.info('#请求方法: ' + method);
            console.info('#请求参数: ');
            console.log(data);
            console.info('#响应: ');
            console.log(dirtyPayload);
            console.groupEnd();
        }

        // 关闭重复请求限制
        delete window._FETCHING[requestUniqueKey];

        // 关闭loading框
        if (loading) {
            store.dispatch( $$BASE.closeLoading() )
        };

        // DISPATCH TYPE
        return next({type: type, result: dirtyPayload, request: action.dirtyPayload, extend: action.extend, origin: action});

    },
    error => {
        window.setTimeout(function(){
            const requestUniqueKey = uniqueFetch(action.dirtyPayload.url, action.dirtyPayload.method);
            delete window._FETCHING[requestUniqueKey];
        }, 500)
        if (loading) {
            store.dispatch( $$BASE.closeLoading() )
        };
        if (process.env.NODE_ENV === 'production') {
            console.log(error);
        }
    })
}
